import { memo } from "react"
import ReactMarkdown from "react-markdown"
import { useSelector } from "react-redux"
import logo from "utils/stylesheets/logo/logo.png"

function Message({ sender, text }) {
  const isBot = sender === "bot"
  const userId = useSelector((state) => state.auth.memberId)
  const initials = useSelector((state) => (userId && state.members[userId] ? state.members[userId].initials : ""))

  return (
    <div className={`chat-message-container ${isBot ? "bot-message" : "user-message"}`}>
      <div className="chat-message-icon">
        {isBot ? (
          <img src={logo} alt="" className="librarian-logo" />
        ) : (
          <span>{(initials || "").slice(0, 2)}</span>
        )}
      </div>
      <div className="chat-message">
        {(text || "").split(/\r?\n|\r|\n/g).map((line, index) => (
          <ReactMarkdown
            key={index}
            components={{
              a: ({ node, children, ...props }) => (
                <a {...props} target="_blank" rel="noopener noreferrer">
                  {children}
                </a>
              ),
            }}
          >
            {line}
          </ReactMarkdown>
        ))}
      </div>
    </div>
  )
}

export default memo(Message)
